import React from 'react';
import ReactDOM from 'react-dom';
import * as serviceWorker from './serviceWorker';
import smoothscroll from 'smoothscroll-polyfill';
import ChargingLocatorApp from 'apps/ChargingLocatorApp';
import 'styles/scss/global/index.scss';

smoothscroll.polyfill();

ReactDOM.render(
  <React.StrictMode>
    <ChargingLocatorApp />
  </React.StrictMode>,
  document.getElementById('charging-locator-root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
